import React, { useState, useEffect } from "react";
import { FaBookOpen } from "react-icons/fa";
// import "../../../../src/assets/css/screens/customer/about us/About.css"; // CSS path adjust karein

const Storysection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animation trigger
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="about-story-section">
      <div className="about-story-container">
        <div className="about-story-grid">
          {/* Story Content */}
          <div className={`about-story-content ${isVisible ? 'about-slide-left' : ''}`}>
            <div className="about-section-badge">
              <span className="about-badge-text"><FaBookOpen/>  OUR STORY</span>
            </div>

            <h2 className="about-section-title">
              Making Services Simple, Trusted & Accessible
            </h2>

            <p className="about-story-text">
              Picks4Tips was created with a simple goal: to make it easier for people
              to find the right professionals for their service needs. We understand
              how difficult it can be to find skilled, reliable, and trustworthy
              professionals when you need a job done.
            </p>

            <p className="about-story-text">
              Our platform brings service seekers and responders together in one
              place, making it easier to post jobs, find suitable professionals,
              connect with them, and get the work done with confidence.
            </p>

            <div className="about-story-features">
              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Verified Professionals</span>
              </div>

              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Trusted Service Experience</span>
              </div>

              <div className="about-story-feature">
                <span className="about-feature-check">✓</span>
                <span>Reliable Support</span>
              </div>
            </div>
          </div>

          {/* Story Image */}
          <div className={`about-story-image ${isVisible ? 'about-slide-right' : ''}`}>
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop"
              alt="Picks4Tips Team"
              className="about-story-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Storysection;